import * as React from 'react';

import {Card} from '../card/card';
import {ModalLightbox} from '../modal/modal-lightbox';

import styles from './support-modal.module.css';

type Props = {
    onClose: () => void;
};

export function SupportModalConfirmation(props: Props) {
    return (
        <ModalLightbox onClose={props.onClose}>
            <Card hasBorder={true}>
                <div className={styles['confirmation-content']}>
                    Thanks! Our team will be in touch soon.
                </div>
            </Card>
        </ModalLightbox>
    );
}
